<template>
  <v-container class="py-0">
    <v-row class="flex-nowrap">
      <v-text-field
        v-bind="$attrs"
        :value="model"
        :rules="componentRules"
        height="32"
        @input="onInput"
        @paste="$emit('paste', $event)"
      >
        <template #prepend-inner>
          <v-select
            v-model="country"
            :items="countries"
            background-color="transparent"
            tabindex="-1"
            flat
            solo
            :readonly="$attrs.readonly"
            item-value="callingCode"
            append-icon
            hide-details
            style="margin-top: -20px; max-width: 40px; min-width: 50px"
            @change="onChange"
          >
            <template #selection="{ item }">
              <app-country-flag
                :country="item.country"
                style="margin-left: -1.5rem; margin-right: -1.5rem; margin-bottom: -16px"
              />
            </template>
            <template #item="{ item }">
              <app-country-flag :country="item.country" />
              <span>{{ item.country }} (+{{ item.callingCode }})</span>
            </template>
          </v-select>
        </template>
      </v-text-field>
    </v-row>
  </v-container>
</template>
<script>
import {
  parsePhoneNumber,
  ParseError,
  getCountries,
  getCountryCallingCode,
  AsYouType,
} from "libphonenumber-js";
import CountryFlag from "vue-country-flag";
import countries from "../utils/countries";

export default {
  components: {
    appCountryFlag: CountryFlag,
  },
  props: {
    rules: {
      type: Array,
      required: false,
    },
    value: String,
    defaultCountry: {
      type: Object,
      required: false,
      default: () => countries[0],
    },
    noDefault: Boolean,
  },
  data() {
    return {
      model: "",
      countries: countries,
      countryCodes: getCountries(),
      country: null,
      phoneRule: (v) => {
        if (!v) {
          return true;
        }
        if (typeof v !== "string") {
          return "Introduce a phone number";
        }
        if (v.length < 5) {
          return true;
        }
        try {
          let value = v;
          if (!value.includes("+")) {
            value = "+" + value;
          }
          const number = parsePhoneNumber(value);
          if (number.isValid()) {
            return true;
          }
          return "Invalid phone number";
        } catch (error) {
          if (error instanceof ParseError) {
            return "Invalid phone number";
          } else {
            return "Error";
          }
        }
      },
    };
  },
  computed: {
    componentRules() {
      return [...(this.rules || []), this.phoneRule];
    },
  },
  methods: {
    onInput(v) {
      try {
        let value = v;
        if (!value.includes("+")) {
          value = "+" + value;
        }
        const number = parsePhoneNumber(value);
        if (number.countryCallingCode !== this.country?.callingCode) {
          this.country =
            this.countries.find((country) => country.callingCode === number.countryCallingCode) ||
            null;
        }
        this.model = new AsYouType().input(value);
        this.$emit("input", this.model);
      } catch (error) {
        this.$emit("input", v);
      }
    },
    getCallingCode(code) {
      const newCode = code.toUpperCase();
      if (this.countryCodes.includes(newCode)) {
        return getCountryCallingCode(newCode);
      }
      return "";
    },
    onChange(payload) {
      this.model = "+" + payload;
    },
  },
  created() {
    this.country = this.defaultCountry || this.countries[0];
    if (this.value) {
      this.model = this.value;
    } else if (!this.noDefault) this.model = "+" + this.country?.callingCode;
  },
  watch: {
    value(value) {
      this.model = value;
    },
    model(value) {
      this.onInput(value);
    },
  },
};
</script>
